import React, { useState } from 'react';
import IconSearch from '../icons/search';
import IconCancel from '../icons/cancel';
import styled, { css } from 'styled-components';

const StyledContainer = styled.div<{ selected: boolean }>`
    display: flex;
    justify-content: space-between;
    background-color: ${props => props.theme.colours.offLight};
    border: 2px solid ${props => (props.selected ? props.theme.colours.midGrey : props.theme.colours.borderGrey)};
    border-radius: 3px;
    ${props => props.theme.transition};
    width: 100%;
`;

const StyledInput = styled.input`
    font-family: inherit;
    border: none;
    background-color: ${props => props.theme.colours.offLight};
    padding: 7px;
    font-size: 13px;
`;

const StyledIconBaseStyles = css`
    height: 18px;
    cursor: pointer;
    float: right;
`;

const StyledIconSearch = styled(IconSearch)`
    ${StyledIconBaseStyles}
    color: ${props => props.theme.colours.midGrey};
    margin: 6px;
`;

const StyledIconCancel = styled(IconCancel)`
    ${StyledIconBaseStyles}
    color: ${props => props.theme.colours.red};
    fill-opacity: 0.5;
    margin: 6px 6px 2px 0px;
    &:hover {
        fill-opacity: 0.8;
    }
`;

export type TableSearchProps = {
    searchValue: string;
    placeholder: string;
    onChange: () => void;
    onClear: () => void;
    hidden: boolean;
};

const TableSearch = ({ searchValue, placeholder, onChange, onClear, hidden }: TableSearchProps) => {
    const [selected, setSelected] = useState(false);

    const onInputFocus = () => {
        setSelected(true);
    };

    const onInputBlur = () => {
        setSelected(false);
    };

    if (!hidden) {
        return (
            <StyledContainer onFocus={onInputFocus} onBlur={onInputBlur} selected={selected}>
                <StyledInput type="text" onChange={onChange} value={searchValue} placeholder={placeholder} />
                {searchValue !== '' ? (
                    <div onClick={onClear}>
                        <StyledIconCancel />
                    </div>
                ) : (
                    <StyledIconSearch />
                )}
            </StyledContainer>
        );
    } else {
        return null;
    }
};

export default TableSearch;
